// extracted by mini-css-extract-plugin
export default {"faqItem":"FAQItem_faqItem__3f5ee","faqItem__icon":"FAQItem_faqItem__icon__2IOdb"};